export default __webpack_public_path__ + "static/media/folio-icon.6e5889ed.svg";